import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { PAGE_TEXT } from '../../../constants/system-pages.constants';
import { clearSystemPageAccess } from '../../../../guard/navigation-flag.guard';
import { LoginService } from '../../../services/login-service/login.service';

@Component({
  selector: 'app-unauthorized-page',
  imports: [],
  templateUrl: './unauthorized-page.html',
  styleUrl: './unauthorized-page.scss',
})
export class UnauthorizedPage {
  private authService = inject(MsalService);
  private readonly loginService = inject(LoginService);
  protected readonly text = PAGE_TEXT.unauthorized; 
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goHome(): void {
    this.logout();
  }

  logout(): void {
  localStorage.removeItem('tokenId');
  this.loginService.clearUsername();

  const accounts = this.authService.instance.getAllAccounts();

  let activeAccount = this.authService.instance.getActiveAccount();
  if (!activeAccount && accounts.length > 0) {
    activeAccount = accounts[0];
    this.authService.instance.setActiveAccount(activeAccount);
  }

  this.authService.instance.logoutRedirect({
    account: activeAccount,
    postLogoutRedirectUri: '/',
  });
}

ngOnDestroy(): void {
    clearSystemPageAccess();
  }
}
